import { css } from '@emotion/css'
import { accessiblyHidden, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  accessiblyHidden: css(accessiblyHidden),

  indicator: css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.default,

    // Draws the indicator circle.
    '::before': {
      content: "''",
      display: 'block',
      width: 8,
      height: 8,
      borderRadius: 100,
      backgroundColor: colors.amethyst,
      position: 'absolute',
    },

    // Extends the "hover target" of the indicator circle.
    '::after': {
      content: "''",
      display: 'block',
      width: 20,
      height: 28,
      borderRadius: 100,
      position: 'absolute',
    },
  }),
}

export default styles
